import script from "./nav-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./nav-bar.vue?vue&type=script&setup=true&lang=js"

import "./nav-bar.vue?vue&type=style&index=0&id=5c144eaa&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c144eaa"]])

export default __exports__